import { BenefitDTO, NewsBenefitDetailsDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class NewsBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsNews = activeBenefit.details as NewsBenefitDetailsDTO;

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/news',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.${detailsNews.unreadArticles ? 'description' : 'noArticles'}`,
      descriptionValues: { count: detailsNews.unreadArticles },
      benefitProgress: 100,
      badgeValue: detailsNews.unreadArticles,
    };
  }
}
